/* eslint-disable max-len */
import React, { useRef } from 'react';
import { IconButton, InputBase, styled } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

interface StyledInputBaseProps {
    width?: string | number;
    disabled?: boolean;
    value?: string | number;
}

interface CustomSearchProps {
    placeholder?: string;
    value?: string | number;
    handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	setValue?: (value: string | number) => void;
    disabled?: boolean;
    classname?: string;
    width?: string | number;
	from?: string;
	initialValue?: string | number;
	createTaskValue?:any
}

// eslint-disable-next-line max-len
const StyledInputBase = styled(InputBase)<StyledInputBaseProps>(({ theme, disabled, value, width }) => ({
	'& .MuiInputBase-input' : {
		paddingRight : theme.spacing(1),
		transition   : theme.transitions.create('width'),
		width        : (value ? width || '200px' : '0px'),
		'&:focus'    : {
			width  : width || '200px',
			cursor : 'text'
		},
		cursor : disabled ? 'default' : 'text'
	},
	'& .MuiInputAdornment-root, & .MuiIconButton-root' : {
		cursor        : disabled ? 'default' : 'pointer',
		opacity       : disabled ? 0.5 : 1,
		pointerEvents : disabled ? 'none' : 'auto',
		padding       : 'var(--pixel4)'
	}
}));

const CustomSearch: React.FC<CustomSearchProps> = (props) =>
{
	const inputRef = useRef<any>(null);
	const { placeholder, value, handleChange,
		setValue, disabled, classname, width } = props;

	const handleSearchClick = () =>
	{
		if (inputRef.current)
		{
			inputRef.current.focus();
		}
	};

	const handleChangeInternal = (event: React.ChangeEvent<HTMLInputElement>) =>
	{
		// Remove leading spaces and call external handler
		const trimmedValue = event.target.value.replace(/^\s+/, '');

		if (handleChange)
		{
			handleChange(event);
		}
		if (setValue)
		{
			setValue(trimmedValue);
		}
	};

	return (
		<>
			<StyledInputBase
				className={classname || 'whiteBg'}
				inputRef={inputRef}
				type='search'
				width={width}
				placeholder={placeholder}
				value={value ?? ''}
				onChange={handleChangeInternal}
				disabled={disabled}
				startAdornment={
					<IconButton onClick={handleSearchClick} disabled={disabled}>
						<SearchIcon color='action' />
					</IconButton>
				}
			/>

		</>
	);
};

export default CustomSearch;
